import {
  ALLOCATIONS,
  GoalType,
  Portfolio,
  COLORSCHEME,
} from "@/common/widgets/portfolio/util";
import { Text } from "@/common/components/themed";
import { PieChartDataProps } from "@/common/components/charts/pie-chart";
import PieChart from "@/common/components/charts/pie-chart";
import { LineChartOutlined } from "@ant-design/icons";
import "./allocation-widgets.scss";

type AllocationComponentProps = {
  goal: GoalType | "Overall";
  portfolio: Portfolio;
};

export function AllocationList({ goal, portfolio }: AllocationComponentProps) {
  const enabledAllocations = ALLOCATIONS.filter(
    (key) => portfolio.allocations[key] !== undefined,
  );

  const values = enabledAllocations.map((key) => portfolio.allocations[key]!);
  const colors = enabledAllocations.map((key) => COLORSCHEME[goal][key]);
  const total = values.reduce((sum, value) => sum + value, 0);

  const pieChartData = convertToPieChartData(
    values,
    colors,
    enabledAllocations,
  );

  return (
    <div className="allocation-list">
      <PieChart
        name={goal}
        data={pieChartData}
        total={total}
        themeColors={{
          backgroundColor: "#222222",
          textColor: "#ABABAB",
          lightColor: "#FFFFFF",
        }}
      />
      <DateLabel
        goal={goal}
        portfolio={portfolio}
        style={{ color: "#ABABAB" }}
      />
      {pieChartData.map((item, index) => {
        return (
          <div
            className="selected"
            key={`allocation-list-item${item.name + index}`}
          >
            {/* <div className="name">
                <LineChartOutlined style={{
                  color: "black", 
                  backgroundColor: item.itemStyle.color, 
                  width: 24, 
                  height: 24, 
                  borderRadius: 12,
                  fontSize: 25
                }} />{item.name}
              </div> */}
            <div className="name">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: item.itemStyle.color,
                  width: 30,
                  height: 30,
                  borderRadius: "50%",
                }}
              >
                <LineChartOutlined
                  style={{
                    color: "black",
                    fontSize: 18,
                  }}
                />
              </div>
              <span style={{ marginLeft: 8 }}>{item.name}</span>
            </div>
            <div className="value">{formatPercentage(item.value / total)}</div>
          </div>
        );
      })}
    </div>
  );
}

function convertToPieChartData(
  values: number[],
  colors: string[],
  labels: string[],
): PieChartDataProps {
  if (values.length !== colors.length) {
    throw new Error("Values and colors arrays must have the same length.");
  }

  const data = values.map((value, index) => ({
    value,
    name: labels[index] || `Label ${index + 1}`,
    itemStyle: { color: colors[index] },
  }));

  return data;
}

type DateLabelProps = AllocationComponentProps & {
  style?: React.CSSProperties;
};

function DateLabel({ goal, style }: DateLabelProps) {
  return (
    <Text className="date-label" style={style}>
      {goal} asset allocation as of {new Date().toLocaleDateString()}
    </Text>
  );
}

function formatPercentage(percentage: number, toFixedIndex: number = 0) {
  const res = percentage * 100;
  return `${res.toFixed(toFixedIndex)}%`;
}
